/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';
import type { LoginUser } from './LoginUser';
import {
    LoginUserFromJSON,
    LoginUserFromJSONTyped,
    LoginUserToJSON,
    LoginUserToJSONTyped,
} from './LoginUser';

/**
 * 
 * @export
 * @interface ResponseLoginUser
 */
export interface ResponseLoginUser {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseLoginUser
     */
    result: ResponseResult;
    /**
     * 
     * @type {LoginUser}
     * @memberof ResponseLoginUser
     */
    data: LoginUser | null;
}

/**
 * Check if a given object implements the ResponseLoginUser interface.
 */
export function instanceOfResponseLoginUser(value: object): value is ResponseLoginUser {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseLoginUserFromJSON(json: any): ResponseLoginUser {
    return ResponseLoginUserFromJSONTyped(json, false);
}

export function ResponseLoginUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseLoginUser {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': LoginUserFromJSON(json['data']),
    };
}

export function ResponseLoginUserToJSON(json: any): ResponseLoginUser {
    return ResponseLoginUserToJSONTyped(json, false);
}

export function ResponseLoginUserToJSONTyped(value?: ResponseLoginUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': LoginUserToJSON(value['data']),
    };
}

